export const blockIconsUiactionsLogoutNew = (
	<span className='material-symbols-outlined'>logout</span>
);
